import React from "react";
import styles from "./Tearms.module.scss";
const TeramsandConditions = () => {
  return (
    <div className={styles?.mainterms}>
      <div className="fw-bold mt-4 mb-5 fs-2 text-center">
        Privacy Policy and Terms & Conditions
      </div>
      <b>StartupHirers</b>, a platform dedicated to providing training and
      placement services to job seekers and employers. By accessing or using our
      website, you agree to comply with and be bound by the following Terms and
      Conditions. Please read these terms carefully before using our services.
      <br /> <br />
      1. <b>Acceptance of Terms</b> By accessing and using our website, you
      agree to these Terms and Conditions, as well as any additional terms and
      conditions that may apply to specific sections of the website or to
      services and products available through the website. If you do not agree
      to these terms, please do not use our website.
      <br />
      2. <b> Changes to Terms </b>We reserve the right to modify these Terms and
      Conditions at any time. Any changes will be effective immediately upon
      posting on our website. Your continued use of the website after any
      changes constitute your acceptance of the revised terms.
      <br />
      3. <b>Services Provided</b> StartupHirers offers training programs, job
      placement services, and other related services. We strive to provide
      accurate and up-to-date information but do not guarantee the availability,
      accuracy, or completeness of our services.
      <br />
      4. <b>User Responsibilities</b> Users agree to use the website in a lawful
      manner and not to engage in any activities that could harm the website,
      its users, or third parties. Users are responsible for maintaining the
      confidentiality of their account information and for all activities that
      occur under their account.
      <br />
      5. <b>Privacy Policy</b> Your use of the website is also governed by our
      Privacy Policy. By using the website, you consent to the collection and
      use of your information as outlined in the Privacy Policy.
      <br />
      6. <b>Intellectual Property</b> All content on the website, including
      text, graphics, logos, and software, is the property of StartupHirers, or
      its content suppliers and is protected by intellectual property laws. You
      may not reproduce, distribute, or create derivative works from any content
      without our prior written permission.
      <br />
      7. <b>Limitation of Liability</b> StartupHirers is not liable for any
      direct, indirect, incidental, or consequential damages arising from the
      use or inability to use our services. We do not guarantee the accuracy,
      completeness, or reliability of any content or services provided on the
      website.
      <br />
      8. <b>Termination</b> We reserve the right to terminate or suspend your
      access to the website at any time, without notice, for any reason,
      including but not limited to violation of these Terms and Conditions.
      <br />
      9. <b>Governing Law </b> These Terms and Conditions are governed by and
      construed in accordance with the laws of Tamil Nadu, India. Any disputes
      arising from or relating to these terms shall be resolved in the courts of
      Tamil Nadu, India.
      <br />
      10. <b>Contact Information</b> If you have any questions or concerns about
      these Terms and Conditions, please contact us at hr@startuphirers.com
      <br />
      <br />
      <b>Terms & Conditions:</b>
      <div className="ms-3 mt-3 mb-3">
        <b className="fs-4">•</b> If a candidate secures a job placement during
        the training or internship period, the stipend will no longer be
        provided for the remaining duration.
        <br />
        <b className="fs-4">•</b> The company reserves the right to discontinue
        the internship program for candidates who are placed before completing
        the training or internship.
        <br />
        <b className="fs-4">•</b> Candidates must maintain consistent
        attendance, punctuality, and good behaviour throughout the program.
        Failure to comply with these requirements may result in termination of
        their enrolment, with no refund provided.
        <br />
        <b className="fs-4">•</b> Stipends are strictly tied to active
        participation in the program; any unauthorized breaks or withdrawals may
        lead to discontinuation of stipend payments.
        <br />
        <b className="fs-4">•</b> All program fees are non-refundable, and any
        decision to withdraw from the program must be communicated formally.
        <br />
        <b className="fs-4">•</b> While we provide career mentorship and
        placement assistance, job placements are not guaranteed.
        <br />
        <br />
      </div>
      <b> Privacy Policy:</b>
      <br />
      This website is owned by Startup Hirers. We value your privacy and are
      committed to safeguarding the information you share with us. At Startup
      Hirers, we ensure transparency in how we collect, store, and use your
      information. Please note that this policy applies solely to our website
      and services and does not extend to third-party websites, which may have
      separate terms and conditions. By using our website, you agree to the
      terms of this Privacy Policy.
      <br /> <br />
      <b>Information We Collect:</b>
      <br />
      You can browse our website without disclosing personal information.
      However, during certain interactions—such as signing up for the internship
      program or filling out forms—you may provide details about yourself. By
      doing so, you consent to our collection and usage of this information for
      the purposes outlined below.
      <br />
      The types of information we collect include:
      <br />
      <br />
      <div className="ms-3">
        <b className="fs-4">•</b> Personal Details: Name, email ID, mobile
        number, location preferences, and program preferences.
        <br />
        <b className="fs-4">•</b> Program Details: Selection of the internship
        program, preferred start date, and any other program-specific details
        you provide.
        <br />
        <b className="fs-4">•</b> Communication Records: Emails, direct
        inquiries, and messages sent to us.
        <br />
        <b className="fs-4">•</b> Website Data: Information automatically
        recorded through cookies and server logs, such as your IP address,
        browser type, referring/exit pages, and pages visited on our website.
        This data does not personally identify you and is collected to analyze
        user trends and enhance the website experience.
      </div>
      <br />
      <b>Usage of Information:</b>
      <br />
      <div className="mt-2 mb-3">The information we collect is used to:</div>
      1. Explain our internship programs, services, and processes to you in
      detail.
      <br />
      2. Enhance the quality of our offerings based on user feedback and
      preferences.
      <br />
      3. Facilitate communication through our program counselors, who may
      contact you to provide guidance or program details.
      <br />
      4. Analyze website traffic, improve navigation, and ensure a personalized
      experience for users.
      <br />
      5. Measure the effectiveness of our outreach and marketing efforts.
      <br />
      <br />
      <b>Your Consent:</b>
      <br />
      By submitting your information to Startup Hirers, you acknowledge that you
      have reviewed this Privacy Policy and agree to the outlined usage of your
      information. Our tele-counselors may reach out to you to explain our
      programs and services in detail. Rest assured, your information is handled
      with care, and your privacy is our priority. If you have any questions or
      concerns, feel free to contact us for clarification
    </div>
  );
};

export default TeramsandConditions;
